import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { BasePageComponent } from '../../base-page/base-page.component';

@Component({
  selector: 'app-support-faq-self-tab',
  templateUrl: './support-faq-self-tab.component.html',
  styleUrls: ['./support-faq-self-tab.component.scss']
})
export class SupportFaqSelfTabComponent extends BasePageComponent implements OnInit {
  tabIndex: number = -1;
  constructor(
    private route: ActivatedRoute,
    protected licenceService: LicenceService
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.data.pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.tabIndex = res.tabIndex;
    })
  }

  selectedTab(index: any) {
    console.log(index)
    this.tabIndex = index.index;
  }

}
